import { ComponentPropsWithoutRef, memo } from "react";

import { ArrowRightWhite } from "@hl/base-components/lib/assets/icons.generated";
import { Button, ButtonProps } from "@mantine/core";

type NextStepButtonProps = ButtonProps & ComponentPropsWithoutRef<"button">;

const NextStepButton = ({
  size = "lg",
  type = "submit",
  children = "Next step",
  ...rest
}: NextStepButtonProps) => {
  return (
    <Button
      type={type}
      size={size}
      px={16}
      rightIcon={<ArrowRightWhite />}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default memo(NextStepButton);
